import { useEffect } from 'react';
import { useTeam } from '@/contexts/TeamContext';
import { hexToHsl } from '@/lib/colorUtils';

export const TeamThemeHandler = (): null => {
    const { currentTeam } = useTeam();

    useEffect(() => {
        const documentElement = document.documentElement;

        if (currentTeam) {
            // Handle Primary Color
            if (currentTeam.themePrimaryColor) {
                // Set the raw hex for components that might use it directly (if any)
                documentElement.style.setProperty('--theme-primary', currentTeam.themePrimaryColor);

                // Convert to HSL for Tailwind/Shadcn components
                const hsl = hexToHsl(currentTeam.themePrimaryColor);
                if (hsl) {
                    documentElement.style.setProperty('--primary', hsl);
                    documentElement.style.setProperty('--ring', hsl);
                    // We might want to calculate a contrasting foreground, but for now assuming white/light is safe
                    // or keeping default foreground if it's dark
                    // Ideally we'd calculate contrast here too.
                }
            } else {
                documentElement.style.removeProperty('--theme-primary');
                documentElement.style.removeProperty('--primary');
                documentElement.style.removeProperty('--ring');
            }

            // Handle Action Button Background
            if (currentTeam.actionButtonBgColor) {
                documentElement.style.setProperty('--theme-action-bg', currentTeam.actionButtonBgColor);
            } else {
                documentElement.style.removeProperty('--theme-action-bg');
            }

            // Handle Action Button Icon
            if (currentTeam.actionButtonIconColor) {
                documentElement.style.setProperty('--theme-action-icon', currentTeam.actionButtonIconColor);
            } else {
                documentElement.style.removeProperty('--theme-action-icon');
            }
        }
    }, [currentTeam]);

    return null;
};
